import { Box, Grid, Avatar, Typography, styled, Paper } from "@mui/material";
import { FC } from "react";

import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";

interface ICardInfoProps {
  message?: string;
}

export const CardInfo: FC<ICardInfoProps> = (props) => {
  return (
    <Box p={1}>
      <Paper elevation={3}>
        <Grid container spacing={2} p={2}>
          <Grid item>
            <TipsAndUpdatesIcon fontSize="large" color="info" />
          </Grid>
          <Grid item xs>
            <Typography>{props.message}</Typography>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};
